// Generated from releases.json. Do not edit.
export const APP_VERSION = "0.19.1" as const
export const RELEASES = [
  {
    "version": "0.19.1",
    "publishedAt": "2026-10-11T08:00:00.000Z",
    "summary": "Nuova icona dell’app (pagina a blocchi) e favicon, colori più vivaci, tolto il nome accanto al logo.",
    "areas": [
      {
        "area": "Aspetto",
        "items": [
          "Nuova icona a blocchi di contenuto (intestazione, corpo, riquadri) per scheda del browser, schermata Home e installazione come app.",
          "Arancio del marchio, stati (successo, avviso, errore, info) e contenitori più saturi, in chiaro e in scuro.",
          "Tolta la scritta «Migliore CMS» accanto al logo, in alto e nel login."
        ]
      }
    ]
  },
  {
    "version": "0.19.0",
    "publishedAt": "2026-10-10T16:58:07.251Z",
    "summary": "Contenuti riordinati: albero per sezione, una sola lingua con le traduzioni dentro, miniature, editor leggibile senza JSON e modifica sul sito più facile da trovare.",
    "areas": [
      {
        "area": "Elenco contenuti",
        "items": [
          "Albero per sezione (Blog, Corsi…) costruito dall’indirizzo pubblico, con home e pagine singole in cima.",
          "Si vede solo la lingua principale; le traduzioni sono dentro ogni voce, con «manca EN» dove non c’è.",
          "Miniatura dell’immagine principale su ogni riga, trovata anche nei dati importati."
        ]
      },
      {
        "area": "Modifica del contenuto",
        "items": [
          "Niente più JSON né «null»: gruppi con etichette in italiano, liste, interruttori, date, immagini con anteprima.",
          "Testo formattato con editor visuale; dettagli tecnici in una sezione chiusa.",
          "Pagina in ordine: titolo e immagine, stato, contenuto, SEO con anteprima Google, traduzioni."
        ]
      },
      {
        "area": "Modifica sul sito",
        "items": [
          "Vale anche «?cms-edit»; barra in alto con Salva ed Esci e tasto «Modifica» discreto.",
          "Campo Titolo nella barra; dopo il salvataggio dice come pubblicare."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Contents reorganised: a tree by section, one language with translations inside, thumbnails, a readable editor without JSON and easier editing on the site.",
        "areas": [
          {
            "area": "Content list",
            "items": [
              "Tree by section (Blog, Courses…) built from the public address, with home and single pages on top.",
              "Only the main language is shown; translations sit inside each entry, with “EN missing” where absent.",
              "Thumbnail of the main image on every row, also found in imported data."
            ]
          },
          {
            "area": "Editing a content",
            "items": [
              "No more JSON or “null”: labelled groups, lists, switches, dates, images with preview.",
              "Rich text visual editor; technical details in a closed section.",
              "Page in order: title and image, status, content, SEO with Google preview, translations."
            ]
          },
          {
            "area": "Editing on the site",
            "items": [
              "“?cms-edit” works too; top bar with Save and Exit and a discreet “Edit” button.",
              "Title field in the bar; after saving it says how to publish."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.18.3",
    "publishedAt": "2026-10-10T17:00:00.000Z",
    "summary": "Il menu laterale si avvicina allo stile di Google: voci a pillola più ariose, titoli dei gruppi in minuscolo e pulsante «Nuovo contenuto» in tinta morbida.",
    "areas": [
      {
        "area": "Menu laterale",
        "items": [
          "Voci più alte e leggibili, con icone grigie che si colorano quando la voce è attiva.",
          "I titoli dei gruppi non sono più in maiuscolo spaziato.",
          "«Nuovo contenuto» usa un colore chiaro come il «Scrivi» di Gmail."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The side menu moves closer to Google’s style: roomier pill items, sentence-case group titles and a soft-tinted “New content” button.",
        "areas": [
          {
            "area": "Side menu",
            "items": [
              "Taller, easier-to-read items, with grey icons that take colour when the item is active.",
              "Group titles are no longer in spaced capitals.",
              "“New content” uses a light colour like Gmail’s “Compose”."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.18.2",
    "publishedAt": "2026-10-10T16:00:00.000Z",
    "summary": "Anche nell’anteprima dei layout la sezione scelta nell’albero viene evidenziata.",
    "areas": [
      {
        "area": "Layout",
        "items": [
          "Scegliendo una sezione di partenza di una regione, l’anteprima del layout la evidenzia e scorre fin lì; cliccandola nell’anteprima la selezioni nell’albero."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The layout preview now highlights the section picked in the tree too.",
        "areas": [
          {
            "area": "Layouts",
            "items": [
              "Picking a default section of a region highlights it in the layout preview and scrolls to it; clicking it in the preview selects it in the tree."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.18.1",
    "publishedAt": "2026-10-10T15:00:00.000Z",
    "summary": "Anche i risultati della ricerca rapida (Ctrl+K) mostrano la miniatura dell’immagine principale.",
    "areas": [
      {
        "area": "Miniature",
        "items": [
          "I contenuti trovati con la ricerca in alto, anche di altri siti, mostrano la copertina in miniatura; se manca resta l’icona."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Quick search (Ctrl+K) results now show the main image thumbnail too.",
        "areas": [
          {
            "area": "Thumbnails",
            "items": [
              "Contents found with the top search, including other sites, show their cover as a thumbnail; the icon stays when there is none."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.18.0",
    "publishedAt": "2026-10-10T14:00:00.000Z",
    "summary": "Meno pulsanti ripetuti: «Pubblica sito» e «Nuovo contenuto» stanno in un posto solo.",
    "areas": [
      {
        "area": "Interfaccia",
        "items": [
          "«Pubblica sito» è solo nella barra in alto, sempre visibile (anche sul telefono, come icona): tolto dalle intestazioni di Contenuti, Panoramica, Pagine e Pubblicazioni.",
          "«Nuovo contenuto» è solo nel menu laterale: tolto dall’intestazione dell’elenco e dalla Panoramica. Nell’elenco vuoto resta l’invito a crearne uno."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Fewer repeated buttons: “Publish site” and “New content” live in one place only.",
        "areas": [
          {
            "area": "Interface",
            "items": [
              "“Publish site” is only in the top bar, always visible (an icon on phones): removed from the headers of Content, Overview, Pages and Publications.",
              "“New content” is only in the side menu: removed from the list header and the Overview. The empty list keeps its prompt to create one."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.17.1",
    "publishedAt": "2026-10-10T18:00:00.000Z",
    "summary": "Collaudo nel browser delle schermate nuove: corretti il menu creato dal sito di partenza, il cestino che lasciava pagine orfane e alcuni difetti di impaginazione.",
    "areas": [
      {
        "area": "Correzioni",
        "items": [
          "Cestino: una pagina con pagine sotto di sé non si sposta più nel cestino; l’errore elenca le pagine figlie e dice come procedere.",
          "Il menu principale creato con il sito di partenza ora si può salvare dalla schermata Menu.",
          "Anteprima del menu: con voci o colonne ancora senza nome compare una frase chiara invece di un errore.",
          "Dettaglio pagina: l’errore di pubblicazione scorre in vista; le colonne laterali lunghe scorrono da sole.",
          "Tema: l’elenco delle varianti di colore non mostra più «undefined».",
          "Generazione AI: le finestre di immagine e video si riaprono senza restare bloccate."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Browser testing of the new screens: fixed the menu created by the starter site, the trash that left orphan pages, and a few layout defects.",
        "areas": [
          {
            "area": "Fixes",
            "items": [
              "Trash: a page that still has pages below it no longer goes to the trash; the error lists the child pages and says how to proceed.",
              "The main menu created with the starter site can now be saved from the Menu screen.",
              "Menu preview: with entries or columns still unnamed, a clear sentence appears instead of an error.",
              "Page detail: the publishing error scrolls into view; long side columns scroll on their own.",
              "Theme: the list of colour variants no longer shows “undefined”.",
              "AI generation: the image and video dialogs reopen without getting stuck."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.17.0",
    "publishedAt": "2026-10-10T16:00:00.000Z",
    "summary": "L’immagine principale di contenuti e pagine si vede in miniatura: negli elenchi, nell’editor, nel calendario, nel piano editoriale, nel menu e nella storia delle versioni.",
    "areas": [
      {
        "area": "Miniature",
        "items": [
          "Elenco dei contenuti, elenco e albero delle pagine mostrano la copertina in miniatura; se manca resta l’icona del tipo.",
          "L’immagine principale si sceglie con una regola sola: copertina o immagine del contenuto, immagine di condivisione della pagina, oppure la prima immagine delle sue sezioni.",
          "In cima all’editor di contenuto e di pagina c’è l’immagine di ciò che stai modificando, e segue la modifica mentre la fai.",
          "Calendario, piano editoriale (con l’immagine della bozza collegata) e scelta della destinazione nel menu mostrano la stessa miniatura.",
          "Nella storia delle versioni, quando cambia l’immagine compaiono il prima e il dopo."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The main image of contents and pages now shows as a thumbnail: in lists, the editor, the calendar, the editorial plan, the menu and the version history.",
        "areas": [
          {
            "area": "Thumbnails",
            "items": [
              "The content list and the page list and tree show the cover as a thumbnail; the type icon stays when there is none.",
              "The main image follows a single rule: the content cover or image, the page share image, or the first image in its sections.",
              "The content and page editors show the image of what you are editing at the top, and it follows your changes as you make them.",
              "The calendar, the editorial plan (with the picture of the linked draft) and the menu destination picker show the same thumbnail.",
              "In the version history, when the image changes you see before and after."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.16.0",
    "publishedAt": "2026-10-10T10:00:00.000Z",
    "summary": "Restyling dell’interfaccia: menu ordinato per aree, ricerca rapida con Ctrl+K, pulsanti più leggibili e bersagli più comodi sul telefono.",
    "areas": [
      {
        "area": "Navigazione",
        "items": [
          "Il menu laterale è ordinato per aree: Contenuti, Struttura, Pianificazione, Impostazioni e Cliente; le voci sono più compatte, così stanno quasi tutte senza scorrere.",
          "Ctrl+K (⌘K su Mac) apre la ricerca da qualunque schermata: oltre ai contenuti trova le schermate, per saltarci con Invio."
        ]
      },
      {
        "area": "Aspetto",
        "items": [
          "Pulsanti principali con un arancione più scuro: il testo bianco ora supera il contrasto minimo di leggibilità (WCAG AA).",
          "Nel tema scuro i messaggi informativi non sono più di un blu così acceso.",
          "Sul telefono i filtri e i pulsanti piccoli hanno un’area di tocco di 40 pixel."
        ]
      },
      {
        "area": "Sotto il cofano",
        "items": [
          "Livelli di sovrapposizione e spaziature ora sono token unici nel foglio di stile."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Interface restyle: menu grouped by area, quick search with Ctrl+K, more readable buttons and comfier touch targets on phones.",
        "areas": [
          {
            "area": "Navigation",
            "items": [
              "The side menu is grouped by area: Content, Structure, Planning, Settings and Client; entries are more compact so almost all fit without scrolling.",
              "Ctrl+K (⌘K on a Mac) opens search from any screen: besides content it finds screens, to jump to with Enter."
            ]
          },
          {
            "area": "Look",
            "items": [
              "Main buttons use a darker orange: the white text now meets the minimum contrast (WCAG AA).",
              "In the dark theme informational messages are no longer such a bright blue.",
              "On phones filters and small buttons have a 40-pixel touch area."
            ]
          },
          {
            "area": "Under the hood",
            "items": [
              "Stacking layers and spacing are now single tokens in the stylesheet."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.15.0",
    "publishedAt": "2026-10-10T10:00:00.000Z",
    "summary": "Le sezioni di una pagina si vedono e si riordinano come un albero: apri e comprimi i rami, trascina, annida, aggiungi dal catalogo e vedi nell’anteprima quale sezione stai modificando.",
    "areas": [
      {
        "area": "Albero delle sezioni",
        "items": [
          "Nel compositore di pagina e nelle sezioni di partenza dei layout le sezioni sono un albero: titolo ricavato dal contenuto, icona del tipo, indicazione di quelle da query, dello stile e del numero di sottosezioni.",
          "Si usa anche solo da tastiera: frecce per muoversi, Invio per aprire le proprietà, Alt + frecce per spostare e annidare, Canc per rimuovere, M per «Sposta in…».",
          "Puoi trascinare una sezione prima, dentro o dopo un’altra, oppure usare «Sposta in…»; una sezione non può finire dentro se stessa. «Annulla ultima mossa» rimette a posto.",
          "«Aggiungi sezione» apre il catalogo con la ricerca e ti fa scegliere dove inserirla; le sezioni vuote o senza il contenuto indispensabile sono segnalate.",
          "Rami aperti e chiusi si ricordano per ogni pagina, con «Espandi tutto» e «Comprimi tutto»."
        ]
      },
      {
        "area": "Anteprima",
        "items": [
          "Scegliendo una sezione nell’albero l’anteprima la evidenzia e scorre fin lì; cliccando una sezione nell’anteprima la selezioni nell’albero."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "A page’s sections are now a tree you can see and reorder: open and close branches, drag, nest, add from the catalogue and see in the preview which section you are editing.",
        "areas": [
          {
            "area": "Section tree",
            "items": [
              "In the page composer and in the default sections of layouts, sections are a tree: title taken from the content, type icon, and marks for query-fed ones, style and number of subsections.",
              "It works from the keyboard alone: arrows to move, Enter to open the properties, Alt + arrows to reorder and nest, Delete to remove, M for “Move to…”.",
              "Drag a section before, inside or after another, or use “Move to…”; a section cannot end up inside itself. “Undo last move” puts it back.",
              "“Add section” opens the catalogue with search and lets you choose where to insert it; empty sections, or those missing essential content, are flagged.",
              "Open and closed branches are remembered for each page, with “Expand all” and “Collapse all”."
            ]
          },
          {
            "area": "Preview",
            "items": [
              "Picking a section in the tree highlights it in the preview and scrolls to it; clicking a section in the preview selects it in the tree."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.14.0",
    "publishedAt": "2026-10-09T10:00:00.000Z",
    "summary": "Piano editoriale dal tool SEO, generazione con AI di immagini, video e call to action, modifica direttamente sul sito, e le rifiniture di pagine, menu, layout e tema.",
    "areas": [
      {
        "area": "Piano editoriale",
        "items": [
          "Nuova sezione «Piano editoriale»: importa le schede dal tool SEO (o incollando il JSON), le approvi, le pianifichi e crei la bozza dell’articolo con titolo, struttura, link e call to action già pronti.",
          "Le voci pianificate compaiono nel calendario; la scheda segnala le possibili cannibalizzazioni."
        ]
      },
      {
        "area": "AI",
        "items": [
          "Genera immagini, video brevi e call to action direttamente dalla libreria media, dai campi immagine e dal dettaglio pagina.",
          "In una pagina puoi chiedere una proposta di sezioni e accettarla o scartarla: la pagina non cambia finché non accetti."
        ]
      },
      {
        "area": "Modifica sul sito",
        "items": [
          "Dal CMS apri la pagina pubblicata e la modifichi direttamente lì: testi, immagini, sezioni. Modificare non pubblica: poi scegli «Pubblica solo questa pagina» o annulli.",
          "Si accende per sito dalle impostazioni; i lettori del sito non vedono né caricano nulla."
        ]
      },
      {
        "area": "Rifiniture",
        "items": [
          "Pagine tradotte collegate fra loro (hreflang), pagine programmate nel calendario, ritiro di una pagina senza ripubblicare tutto.",
          "Menu: rinomina, elimina, riordina trascinando; layout per tipo di contenuto; il tema pubblica anche le cornici per lingua."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Editorial plan fed by the SEO tool, AI generation of images, videos and calls to action, editing straight on the site, and polish for pages, menus, layouts and theme.",
        "areas": [
          {
            "area": "Editorial plan",
            "items": [
              "New “Editorial plan” section: import briefs from the SEO tool (or paste the JSON), approve them, schedule them and create the article draft with title, structure, links and call to action ready.",
              "Planned items show in the calendar; the brief flags possible cannibalization."
            ]
          },
          {
            "area": "AI",
            "items": [
              "Generate images, short videos and calls to action right from the media library, the image fields and the page detail.",
              "On a page you can ask for a proposal of sections and accept or discard it: the page does not change until you accept."
            ]
          },
          {
            "area": "Edit on the site",
            "items": [
              "From the CMS you open the published page and edit it right there: text, images, sections. Editing does not publish: then you pick “Publish only this page” or undo.",
              "It is switched on per site from the settings; the site’s readers neither see nor load anything."
            ]
          },
          {
            "area": "Polish",
            "items": [
              "Translated pages linked to each other (hreflang), scheduled pages in the calendar, taking a page down without republishing everything.",
              "Menus: rename, delete, reorder by dragging; layout per content type; the theme also publishes the per-language frames."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.13.0",
    "publishedAt": "2026-10-08T22:00:00.000Z",
    "summary": "Menu, layout e tema pilotano il sito: menu a più livelli e mega menu, layout a regioni con bozza e pubblicazione, temi con font, versioni e anteprima su pagine vere.",
    "areas": [
      {
        "area": "Menu",
        "items": [
          "Si gestiscono tutti i menu del sito (principale, piè di pagina e altri), anche con il mega menu a colonne e la voce evidenziata.",
          "Le voci possono puntare alle pagine pubblicate; quelle che non portano da nessuna parte non compaiono e ti avvisano.",
          "Anteprima del menu accanto all’editor."
        ]
      },
      {
        "area": "Layout",
        "items": [
          "Nuova sezione «Layout»: regioni con nome, sezioni di default o un menu, bozza, pubblicazione, ritiro e cestino.",
          "Ogni pagina sceglie il suo layout dal dettaglio; senza scelta il sito resta com’era."
        ]
      },
      {
        "area": "Tema",
        "items": [
          "Font propri del sito, presi dalla libreria dei file.",
          "Il tema ha bozza e versione pubblicata: modificarlo non cambia il sito finché non lo pubblichi, e si può tornare a una versione precedente.",
          "Temi di partenza, duplicazione, blocco del tema e anteprima su una pagina vera del sito."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Menu, layout and theme now drive the site: multi-level and mega menus, regions-based layouts with draft and publishing, themes with fonts, versions and a preview on real pages.",
        "areas": [
          {
            "area": "Menus",
            "items": [
              "Every site menu (main, footer and others) is managed, including the multi-column mega menu with a highlighted item.",
              "Items can point at published pages; the ones that lead nowhere are left out and you get a warning.",
              "A menu preview sits next to the editor."
            ]
          },
          {
            "area": "Layouts",
            "items": [
              "New “Layouts” section: named regions, default sections or a menu, draft, publishing, take-down and trash.",
              "Each page picks its layout from its detail; with no choice the site stays as it was."
            ]
          },
          {
            "area": "Theme",
            "items": [
              "The site’s own fonts, taken from the file library.",
              "The theme has a draft and a published version: editing it does not change the site until you publish it, and you can go back to an earlier version.",
              "Starter themes, duplication, theme lock and a preview on a real page of the site."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.12.1",
    "publishedAt": "2026-10-08T20:00:00.000Z",
    "summary": "Dalla pagina si può mandare online solo lei, senza ripubblicare tutto il sito.",
    "areas": [
      {
        "area": "Pagine",
        "items": [
          "Nuovo pulsante «Pubblica solo questa pagina» nel dettaglio: pubblica la pagina e la manda online da sola, con l’avanzamento della pubblicazione.",
          "Se non si può, lo spiega: distribuzione disattivata, serve prima una pubblicazione completa del sito, oppure il servizio di pubblicazione non risponde.",
          "Il messaggio del ritiro ricorda che la pagina esce dal sito solo con la prossima pubblicazione completa."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "From the page you can send only that page online, without republishing the whole site.",
        "areas": [
          {
            "area": "Pages",
            "items": [
              "New “Publish only this page” button in the detail: it publishes the page and sends it online on its own, with the publication progress.",
              "When it cannot, it explains why: delivery turned off, a full site publication is needed first, or the publishing service is not answering.",
              "The take-down message reminds you that the page leaves the site only with the next full publication."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.12.0",
    "publishedAt": "2026-10-08T18:00:00.000Z",
    "summary": "Le pagine del sito hanno un ciclo di vita: bozza, revisione, pubblicata, programmata e cestino, con SEO e indirizzi ad albero.",
    "areas": [
      {
        "area": "Pagine",
        "items": [
          "L’elenco mostra titolo, indirizzo, stato (bozza, in revisione, pubblicata, nel cestino), il segnale «Modifiche non pubblicate» e la data di uscita programmata; si filtra per stato, si cerca per titolo o indirizzo e si vede ad albero o a elenco.",
          "Nuova pagina con titolo, ultima parte dell’indirizzo e pagina genitore: nasce come bozza e si apre subito il suo dettaglio.",
          "Il dettaglio permette di cambiare titolo e SEO (con i contatori di 70 e 200 caratteri) e di spostare la pagina: le pagine sotto la seguono e i vecchi indirizzi vengono rediretti dopo «Pubblica sito».",
          "Azioni secondo lo stato: invia in revisione, rimanda in bozza, pubblica ora o programma l’uscita, ritira, annulla le modifiche e torna alla versione pubblicata, sposta nel cestino, ripristina.",
          "Gli avvisi dicono come stanno le cose: una pagina nuova non è sul sito finché non è pubblicata, e «pubblicata» vuol dire online solo dopo «Pubblica sito».",
          "Se qualcun altro ha scritto sulla stessa pagina si può ricaricare o riprovare; un rifiuto del gateway si legge per intero. Nuova cronologia della pagina, con chi ha fatto cosa e perché."
        ]
      },
      {
        "area": "Composizione",
        "items": [
          "Le sezioni si compongono ora in «Componi le sezioni», dal dettaglio della pagina; salvare non pubblica, e lo dice."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Site pages now have a lifecycle: draft, review, published, scheduled and trash, with SEO and an address tree.",
        "areas": [
          {
            "area": "Pages",
            "items": [
              "The list shows title, address, status (draft, in review, published, in the trash), the “Unpublished changes” sign and the scheduled release date; filter by status, search by title or address and see it as a tree or a list.",
              "New page with a title, the last part of the address and a parent page: it starts as a draft and its detail opens right away.",
              "The detail lets you change the title and SEO (with the 70 and 200 character counters) and move the page: the pages under it follow and the old addresses are redirected after “Publish site”.",
              "Actions by status: send to review, send back to draft, publish now or schedule the release, take down, discard the changes and go back to the published version, move to the trash, restore.",
              "The notices say how things stand: a new page is not on the site until it is published, and “published” means online only after “Publish site”.",
              "If someone else wrote on the same page you can reload or retry; a gateway refusal is read in full. New page history, with who did what and why."
            ]
          },
          {
            "area": "Composition",
            "items": [
              "Sections are now composed in “Compose the sections”, from the page detail; saving does not publish, and it says so."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.11.2",
    "publishedAt": "2026-09-27T12:00:00.000Z",
    "summary": "La versione nuova del CMS si carica da sola, senza premere Aggiorna.",
    "areas": [
      {
        "area": "Aggiornamento",
        "items": [
          "La versione nuova si carica da sola, senza premere Aggiorna: le novità compaiono dopo il ricaricamento.",
          "Si aggiornano insieme tutte le schede del CMS aperte nel browser; «Ho capito» chiude le novità in tutte."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The new CMS version loads by itself, without pressing Update.",
        "areas": [
          {
            "area": "Update",
            "items": [
              "The new version loads by itself, without pressing Update: what is new shows up after the reload.",
              "Every CMS tab open in the browser updates together; «Got it» closes the notes in all of them."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.11.1",
    "publishedAt": "2026-09-27T06:20:00.000Z",
    "summary": "Una sola conferma aggiorna tutte le finestre aperte del CMS.",
    "areas": [
      {
        "area": "Aggiornamenti",
        "items": [
          "Con l'OK sull'avviso di nuova versione si aggiornano da sole anche le altre schede del CMS aperte nel browser.",
          "Una scheda aperta più tardi con la versione vecchia si aggiorna senza chiedere di nuovo, e l'avviso della versione confermata non ricompare.",
          "Dopo l'aggiornamento resti sulla stessa pagina."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "A single confirmation updates every open CMS window.",
        "areas": [
          {
            "area": "Updates",
            "items": [
              "Pressing OK on the new version notice also updates every other CMS tab open in the browser.",
              "A tab opened later with the old version updates without asking again, and the notice of the confirmed version does not come back.",
              "After the update you stay on the same page."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.11.0",
    "publishedAt": "2026-09-25T18:30:00.000Z",
    "summary": "Le persone del CMS arrivano solo da Security: membri e inviti si scelgono dalla rubrica, nome ed email restano quelli di Security.",
    "areas": [
      {
        "area": "Persone",
        "items": [
          "«Aggiungi persona» non chiede più subject ed email: si cerca la persona nella rubrica di Security, per nome o per email, e la si sceglie.",
          "Anche il nuovo invito si fa scegliendo la persona dalla rubrica di Security: un indirizzo scritto a mano non è più accettato.",
          "Chi non è su Security non si può aggiungere: va prima creato su security.miglioresoftware.com. Chi è già nel cliente o già invitato compare ma non si sceglie.",
          "Se la persona non ha ancora accesso al CMS, lo apre Security nel momento in cui confermi."
        ]
      }
    ]
  },
  {
    "version": "0.10.0",
    "publishedAt": "2026-09-25T18:00:00.000Z",
    "summary": "Scelta del cliente, pannello operatore, inviti e ruoli delle persone, chiavi API e pubblicazione del sito su un progetto Pages con i suoi domini.",
    "areas": [
      {
        "area": "Clienti",
        "items": [
          "Nella barra in alto, accanto al sito, il selettore del cliente: compare quando puoi lavorare su più di un cliente, ricorda la scelta in questo browser e ricarica siti e schermate.",
          "Se il cliente scelto non ti riconosce più come membro, il CMS torna al tuo e lo dice, invece di fallire a ogni richiesta."
        ]
      },
      {
        "area": "Operatore",
        "items": [
          "Nuova sezione «Operatore», solo per gli operatori della piattaforma: tutti i clienti con conteggi e organizzazioni legate, anteprima dei permessi di ciascuno.",
          "«Nuovo cliente» in tre passaggi: cliente e progetto, primo sito con dominio e lingue, email del proprietario e organizzazione di Security facoltativa. O tutto o niente.",
          "Legami fra organizzazione e cliente: crea, revoca (chiude le sessioni nate dal legame) e ripristina."
        ]
      },
      {
        "area": "Persone",
        "items": [
          "«Persone» ha tre schede: membri, inviti e «Prima di accendere i permessi». Si usa anche con i permessi per progetto ancora spenti.",
          "Ruolo nel cliente (proprietario, amministratore, membro) per ogni persona; l’ultimo proprietario non si declassa e il motivo compare in chiaro.",
          "Inviti per email con ruolo, progetti e validità: elenco per stato e revoca. L’anteprima dice chi perderebbe l’accesso accendendo i permessi."
        ]
      },
      {
        "area": "Chiavi API",
        "items": [
          "Nuova sezione «Chiavi API»: elenco, creazione con nome, ruolo o ambiti scelti uno per uno e scadenza, revoca.",
          "Il segreto si vede una volta sola, con «Copia» e l’avviso che non sarà più mostrato."
        ]
      },
      {
        "area": "Pubblicazione del sito",
        "items": [
          "Nelle impostazioni del sito la scheda «Pubblicazione»: progetto Pages del sito e da dove viene, «Crea o adotta progetto Pages».",
          "Ogni dominio con il suo stato (attivo, in attesa, errore, non collegato), «Collega a Pages» e il record CNAME da creare, da copiare con un clic."
        ]
      },
      {
        "area": "Velocità",
        "items": [
          "Le sezioni meno usate (media, calendario, redirect, tema, persone, operatore e altre) si caricano quando le apri: la prima apertura del CMS scarica meno codice."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Client picker, operator panel, invitations and roles for people, API keys and site publishing to a Pages project with its domains.",
        "areas": [
          {
            "area": "Clients",
            "items": [
              "In the top bar, next to the site, the client picker: it shows when you can work on more than one client, remembers the choice in this browser and reloads sites and screens.",
              "If the chosen client no longer recognizes you as a member, the CMS goes back to yours and says so, instead of failing on every request."
            ]
          },
          {
            "area": "Operator",
            "items": [
              "New “Operator” section, for platform operators only: every client with counts and bound organizations, and the permissions preview of each.",
              "“New client” in three steps: client and project, first site with domain and languages, owner email and an optional Security organization. All or nothing.",
              "Bindings between organization and client: create, revoke (closing the sessions born under it) and restore."
            ]
          },
          {
            "area": "People",
            "items": [
              "“People” has three tabs: members, invitations and “Before turning permissions on”. It works even while project permissions are still off.",
              "Role in the client (owner, administrator, member) for each person; the last owner cannot be demoted and the reason is shown plainly.",
              "Invitations by email with role, projects and validity: list by status and revoke. The preview says who would lose access when permissions go on."
            ]
          },
          {
            "area": "API keys",
            "items": [
              "New “API keys” section: list, creation with a name, a role or scopes picked one by one and an expiry, revocation.",
              "The secret is shown only once, with “Copy” and the warning that it will not be shown again."
            ]
          },
          {
            "area": "Site publishing",
            "items": [
              "In the site settings, the “Publishing” tab: the site’s Pages project and where it comes from, “Create or adopt Pages project”.",
              "Each domain with its state (active, pending, error, not attached), “Attach to Pages” and the CNAME record to create, copied in one click."
            ]
          },
          {
            "area": "Speed",
            "items": [
              "The less used sections (media, calendar, redirects, theme, people, operator and more) load when you open them: the first load of the CMS downloads less code."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.9.0",
    "publishedAt": "2026-09-25T12:00:00.000Z",
    "summary": "Libreria media con caricamento e selettore nel campo immagine, calendario delle pubblicazioni programmate e gestione dei redirect del sito.",
    "areas": [
      {
        "area": "Libreria media",
        "items": [
          "Nuova sezione «Media»: anteprime a griglia, ricerca, filtri per tipo e stato, caricamento di più file insieme con trascinamento e barra di avanzamento.",
          "Il dettaglio di un file permette di rinominarlo, spostarlo, scrivere il testo alternativo per ogni lingua, copiare l'indirizzo, archiviarlo e ripristinarlo.",
          "Il campo immagine dei contenuti mostra l'anteprima e offre «Scegli dalla libreria» e «Carica»; l'indirizzo si può ancora incollare a mano."
        ]
      },
      {
        "area": "Calendario",
        "items": [
          "Nuova sezione «Calendario»: le uscite programmate per settimana o in elenco, con il link a ogni contenuto e l'avviso se la distribuzione è spenta.",
          "Nell'editor il riquadro «Programmazione» imposta, cambia o toglie la data e l'ora di pubblicazione: alla data il sito si ripubblica da solo."
        ]
      },
      {
        "area": "Redirect",
        "items": [
          "Nuova sezione «Redirect»: elenco con ricerca e paginazione, aggiunta, modifica e rimozione di redirect 301 e 302.",
          "Gli errori del CMS compaiono in chiaro: giri senza uscita rifiutati, catene compresse in un passaggio solo, limiti di Cloudflare Pages."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Media library with upload and a picker in the image field, a calendar of scheduled publications and management of the site redirects.",
        "areas": [
          {
            "area": "Media library",
            "items": [
              "New “Media” section: grid previews, search, type and status filters, several files uploaded at once by drag and drop with a progress bar.",
              "A file's detail lets you rename or move it, write the alt text for every language, copy its address, archive and restore it.",
              "The image field of a content shows a preview and offers “Choose from the library” and “Upload”; the address can still be pasted by hand."
            ]
          },
          {
            "area": "Calendar",
            "items": [
              "New “Calendar” section: scheduled releases by week or as a list, linking to each content, with a warning when delivery is off.",
              "In the editor the “Scheduling” panel sets, changes or removes the publication date and time: on that date the site republishes by itself."
            ]
          },
          {
            "area": "Redirects",
            "items": [
              "New “Redirects” section: list with search and paging, adding, editing and removing 301 and 302 redirects.",
              "The CMS errors are shown plainly: loops refused, chains collapsed into one hop, Cloudflare Pages limits."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.8.0",
    "publishedAt": "2026-09-24T23:30:00.000Z",
    "summary": "Il CMS cambia faccia: interfaccia Material 3 leggibile, indirizzi veri per ogni schermata e un selettore dei siti come nelle console di Google.",
    "areas": [
      {
        "area": "Navigazione",
        "items": [
          "Ogni schermata, filtro e scheda ha il proprio indirizzo: si apre in una nuova scheda, si copia e si condivide. I vecchi link continuano a funzionare.",
          "Il selettore dei siti si apre in una finestra con ricerca, siti raggruppati per progetto e dominio; cambiando sito resti nella stessa sezione.",
          "La ricerca nella barra superiore trova i contenuti in tutti i siti.",
          "Dopo l'accesso torni esattamente alla pagina che stavi aprendo."
        ]
      },
      {
        "area": "Interfaccia",
        "items": [
          "Testi più grandi, bottoni e campi comodi, menu laterale con tutte le sezioni del sito e tema chiaro o scuro scelto dal menu.",
          "Sul telefono il menu diventa un pannello a scomparsa e nessuna schermata scorre di lato.",
          "Le sezioni delle pagine e le loro proprietà hanno nomi in italiano; le chiavi tecniche restano un dettaglio secondario."
        ]
      },
      {
        "area": "Contenuti",
        "items": [
          "L'elenco è una tabella con filtri a chip, paginazione «1–50 di 564» e scheletro durante il caricamento.",
          "L'editor ha due colonne, un pannello con stato e indirizzo pubblico e una barra di salvataggio sempre visibile.",
          "«Apri sul sito» porta alla pagina pubblicata; «Salva e segna come pubblicato» chiarisce che per andare online serve «Pubblica sito»."
        ]
      },
      {
        "area": "Storico",
        "items": [
          "Il motivo di ogni modifica viene preparato dal CMS; la «Nota per lo storico» serve solo se vuoi scriverne uno tuo."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The CMS gets a new look: a readable Material 3 interface, real addresses for every screen and a site switcher like Google's consoles.",
        "areas": [
          {
            "area": "Navigation",
            "items": [
              "Every screen, filter and tab has its own address: open it in a new tab, copy it, share it. Old links keep working.",
              "The site switcher opens in a dialog with search, sites grouped by project and domain; switching site keeps you in the same section.",
              "The search in the top bar finds content across all sites.",
              "After signing in you land exactly on the page you were opening."
            ]
          },
          {
            "area": "Interface",
            "items": [
              "Larger text, comfortable buttons and fields, a side menu with every section of the site and a light or dark theme chosen from the menu.",
              "On a phone the menu becomes a slide-in panel and no screen scrolls sideways.",
              "Page sections and their properties have readable names; technical keys are a secondary detail."
            ]
          },
          {
            "area": "Content",
            "items": [
              "The list is a table with chip filters, “1–50 of 564” pagination and a skeleton while loading.",
              "The editor has two columns, a side panel with status and public address and an always visible save bar.",
              "“Open on site” goes to the published page; “Save and mark as published” makes clear that going online needs “Publish site”."
            ]
          },
          {
            "area": "History",
            "items": [
              "The CMS prepares the reason for every change; the “Note for the history” is only needed if you want to write your own."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.7.1",
    "publishedAt": "2026-09-24T20:45:00.000Z",
    "summary": "Quando la sessione scade, il CMS riporta all’accesso unico e poi alla stessa pagina, invece di mostrare errori.",
    "areas": [
      {
        "area": "Accesso",
        "items": [
          "Una sessione scaduta durante il lavoro rimanda all’accesso unico e ritorna alla pagina in cui eri.",
          "Le richieste in parallelo alla scadenza del token non chiudono più la sessione."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "When the session expires, the CMS goes back through single sign-on to the same page instead of showing errors.",
        "areas": [
          {
            "area": "Access",
            "items": [
              "A session that expires while you work sends you through single sign-on and back to the page you were on.",
              "Parallel requests at token expiry no longer end the session."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.7.0",
    "publishedAt": "2026-09-24T16:00:00.000Z",
    "summary": "La presentazione del sito diventa un dato del CMS: nome pubblico, elenchi paginati e cornice per lingua si modificano dall’interfaccia.",
    "areas": [
      {
        "area": "Sito",
        "items": [
          "Nelle impostazioni c’è il profilo pubblico: il nome che vedono i visitatori e la descrizione del sito, distinti dall’etichetta interna.",
          "La nuova schermata Elenchi gestisce le pagine che raccolgono articoli, corsi e tecnologie: indirizzo, lingua, dimensione di pagina, layout e testi."
        ]
      },
      {
        "area": "Tema",
        "items": [
          "Ogni lingua del sito può avere la propria cornice (head, intestazione, piè di pagina, script); le lingue senza cornice usano quella predefinita."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "Site presentation becomes CMS data: public name, paginated listings and per-language frame are edited from the interface.",
        "areas": [
          {
            "area": "Site",
            "items": [
              "Settings now include the public profile: the name visitors see and the site description, separate from the internal label.",
              "The new Listings screen manages the pages that collect articles, courses and technologies: address, language, page size, layout and copy."
            ]
          },
          {
            "area": "Theme",
            "items": [
              "Each site language can have its own frame (head, header, footer, scripts); languages without one use the default frame."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.6.0",
    "publishedAt": "2026-09-20T12:48:44.000Z",
    "summary": "Il CMS configura percorsi sorgente espliciti per quattro risorse e prepara la gestione persone dietro un gate operativo verificabile.",
    "areas": [
      {
        "area": "File nel repository",
        "items": [
          "Contenuti, pagine, menu e temi possono dichiarare percorsi metadati e scelta della nuova riga finale senza dedurli da nomi o slug.",
          "I contenuti possono mappare corpi HTML o Markdown a campi espliciti; i temi possono indicare separatamente il CSS scritto a mano.",
          "I conflitti conservano la bozza e offrono ricarica o nuovo tentativo. La configurazione non attiva da sola sincronizzazione Git o pubblicazione."
        ]
      },
      {
        "area": "Accesso e usabilità",
        "items": [
          "La sezione Persone appare solo agli amministratori quando l’API conferma che l’enforcement per progetto è attivo.",
          "Su mobile i campi avanzati restano leggibili e accessibili: la barra di salvataggio principale non copre più il pannello repository."
        ]
      }
    ],
    "translations": {
      "en": {
        "summary": "The CMS configures explicit source paths for four resource types and prepares people management behind a verifiable operational gate.",
        "areas": [
          {
            "area": "Repository files",
            "items": [
              "Contents, pages, menus, and themes can declare metadata paths and final-newline behavior without deriving them from names or slugs.",
              "Contents can map HTML or Markdown bodies to explicit fields; themes can separately identify authored CSS.",
              "Conflicts preserve the draft and offer reload or retry. Configuration alone does not enable Git synchronization or publication."
            ]
          },
          {
            "area": "Access and usability",
            "items": [
              "The People area appears only to administrators when the API confirms that project enforcement is enabled.",
              "Advanced fields remain readable and reachable on mobile: the primary save bar no longer covers the repository panel."
            ]
          }
        ]
      }
    }
  },
  {
    "version": "0.5.0",
    "publishedAt": "2026-09-20T11:00:35.000Z",
    "summary": "Il CMS raccoglie ora la conoscenza aziendale in modo strutturato e permette di ripristinare con cautela una pubblicazione precedente.",
    "areas": [
      {
        "area": "Conoscenza aziendale",
        "items": [
          "Servizi, storia, fondatore, tono di voce, prove, aneddoti e contenuti da evitare hanno uno spazio editoriale dedicato.",
          "La sezione Altro conserva valori strutturati e campi futuri senza ridurli a semplice testo.",
          "Ogni modifica richiede un motivo, usa la versione corrente e protegge il lavoro non ancora salvato."
        ]
      },
      {
        "area": "Pubblicazioni",
        "items": [
          "Una pubblicazione riuscita può essere ripristinata online con conferma esplicita e motivo obbligatorio.",
          "Il ripristino cambia soltanto la versione online: contenuti e bozze nel CMS restano invariati.",
          "Quando manca una base completa, l’interfaccia avvisa che potrebbe servire una nuova pubblicazione integrale."
        ]
      }
    ]
  },
  {
    "version": "0.4.1",
    "publishedAt": "2026-09-20T10:41:00.000Z",
    "summary": "La gestione del sito è più sicura nei passaggi operativi: destinazione autorizzata, modifiche protette e salvataggi riprendibili.",
    "areas": [
      {
        "area": "Affidabilità",
        "items": [
          "La destinazione Cloudflare Pages si può abilitare solo quando l’operatore l’ha associata esattamente al sito.",
          "Domini, lingue, repository e destinazione proteggono le modifiche non salvate prima di cambiare pagina o sito.",
          "Un salvataggio parziale del tema rilegge la versione corrente e conserva solo le modifiche ancora da applicare."
        ]
      },
      {
        "area": "Menu",
        "items": [
          "La scelta dei contenuti attraversa tutta la paginazione dell’API e non si ferma ai primi cento risultati."
        ]
      }
    ]
  },
  {
    "version": "0.4.0",
    "publishedAt": "2026-09-20T10:32:00.000Z",
    "summary": "Il CMS gestisce ora il sito oltre ai contenuti: configurazione, navigazione, tema, pagine, pubblicazioni e impianto completo.",
    "areas": [
      {
        "area": "Gestione del sito",
        "items": [
          "Domini, lingue e repository sono configurabili nel contesto del sito selezionato, con motivo e versione attesa.",
          "Menu annidati, destinazioni reali e libreria delle sezioni hanno editor dedicati e permessi coerenti con l’API.",
          "Temi, token e CSS aggiuntivo si modificano con anteprima di bozza e salvataggio esplicito."
        ]
      },
      {
        "area": "Pagine e impianto",
        "items": [
          "Il compositore organizza sezioni e proprietà accanto all’anteprima prodotta dal renderer reale.",
          "La cronologia delle pubblicazioni mostra avanzamento, destinazione ed eventuali errori senza promettere rollback non disponibile.",
          "Il nuovo impianto crea progetto, sito, tema, tipi, pagine e menu in un’unica operazione senza pubblicare automaticamente."
        ]
      }
    ]
  },
  {
    "version": "0.3.0",
    "publishedAt": "2026-09-20T10:15:00.000Z",
    "summary": "Il CMS è ora un workspace editoriale completo: panoramica reale, navigazione per sito, contenuti filtrabili ed editor organizzato.",
    "areas": [
      {
        "area": "Workspace",
        "items": [
          "Nuova sidebar responsive con contesto sito, panoramica, contenuti e note di rilascio.",
          "Tema chiaro e scuro persistente, navigazione mobile e stato pubblico del sito.",
          "Panoramica costruita solo da conteggi reali dell’API e contenuti modificati di recente."
        ]
      },
      {
        "area": "Editor",
        "items": [
          "Campi organizzati in Contenuto, SEO e Strumenti, con anteprima di ricerca e contatori SEO.",
          "Inspector per dettagli e stato editoriale, distinto dal salvataggio dei campi.",
          "Barra di salvataggio persistente e protezione quando si tenta di uscire con modifiche non salvate."
        ]
      }
    ]
  },
  {
    "version": "0.2.0",
    "publishedAt": "2026-09-20T07:00:00.000Z",
    "summary": "Il lavoro quotidiano sui contenuti è più sicuro: sito, lingua, paginazione, salvataggio e pubblicazione mostrano lo stato reale senza nascondere errori.",
    "areas": [
      {
        "area": "Contenuti",
        "items": [
          "Selezione del sito con dominio, ricerca ritardata e paginazione con intervallo e totale.",
          "Creazione guidata dalle lingue ammesse dal tipo di contenuto.",
          "Modifiche non salvate protette prima di cambiare stato, usare l’AI o cestinare il contenuto."
        ]
      },
      {
        "area": "Pubblicazione",
        "items": [
          "Avanzamento per fase, numero di file preparati e collegamento al sito distribuito.",
          "Errori di caricamento e pubblicazione mostrati con il messaggio restituito dall’API."
        ]
      }
    ]
  },
  {
    "version": "0.1.0",
    "publishedAt": "2026-09-19T12:00:00.000Z",
    "summary": "Il CMS usa l’accesso unico e porta contenuti, cronologia e modifica in pagina nello stesso spazio di lavoro.",
    "areas": [
      {
        "area": "Contenuti",
        "items": [
          "Elenco, filtri, modifica data-driven e campi non mappati nella sezione Altro.",
          "Cronologia completa e rilettura di ogni versione del contenuto.",
          "Modifica direttamente nella pagina resa con il motore del sito."
        ]
      },
      {
        "area": "Accesso",
        "items": [
          "Accesso unico tramite Security con ruoli e permessi applicati dall’API."
        ]
      }
    ]
  }
] as const
